import React, { useRef, useState, useEffect } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { GridCloseIcon } from '@mui/x-data-grid';
import { ThemeProvider } from '@mui/material/styles';

import AppRoutes from './AppRoutes';
import theme from './theme';
import { VoiceAssistantProvider } from './components/shared-components/voice-assistant/VoiceAssistantContext';
import { VoiceAssistant } from './components/shared-components/voice-assistant/VoiceAssistant';
import { HelpProvider } from './components/help';
import Maintenance from './components/maintenance/Maintenance';
import { isMaintenanceModeEnabled } from './utils/maintenanceMode';

import './App.css';

function App(props:any): React.ReactElement {
  const notistackRef: any = useRef();

  return (
    <ThemeProvider theme={theme}>
      <HelpProvider>
        <SnackbarProvider
          ref={notistackRef}
          action={(key) => (
            <Button onClick={() => notistackRef?.current.closeSnackbar(key)} style={{ color: '#fff', fontSize: '20px' }}>
              <GridCloseIcon />
            </Button>
          )}
        >
          <AppRoutes {...props}/>;       
        </SnackbarProvider>
      </HelpProvider>
    </ThemeProvider>
  );
}

export default App;
